import script from "./TheHighlights.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHighlights.vue?vue&type=script&setup=true&lang=js"

import "./TheHighlights.vue?vue&type=style&index=0&id=7c7351f6&lang=scss&scoped=true"

import exportComponent from "/Users/rioschan/Downloads/event-2022electrolux-main/vue-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c7351f6"]])

export default __exports__